import { ModelDataChangeFilterRegistry, ModelDataChangeServerFilter } from "@mcleod/components";

export class ModelDataChangeFilterInitializer {
    public initialize() {
        ModelDataChangeFilterRegistry.get().register(new ModelDataChangeServerFilter());
    }
}
